export function addDragToElement(element, overlay, pageIndex, fieldId, setSignatureFields) {
  if (typeof setSignatureFields !== "function") {
    console.error("addDragToElement: setSignatureFields was not passed for field", fieldId);
    return;
  }

  let offsetX, offsetY;
  let isDragging = false;

  element.dataset.id = fieldId;

  element.addEventListener("mousedown", (e) => {
    if (e.target.closest(".field-icon")) return;

    isDragging = true;

    // Get the initial offset of the element
    const rect = element.getBoundingClientRect();
    offsetX = e.clientX - rect.left;
    offsetY = e.clientY - rect.top;

    // Add the mouse move listener to update position
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  });

  function onMouseMove(e) {
    if (!isDragging) return;

    const overlayRect = overlay.getBoundingClientRect();

    let newX = e.clientX - offsetX - overlayRect.left;
    let newY = e.clientY - offsetY - overlayRect.top;

    // Prevent going outside the overlay bounds
    newX = Math.max(0, Math.min(newX, overlayRect.width - element.offsetWidth));
    newY = Math.max(0, Math.min(newY, overlayRect.height - element.offsetHeight));

    // Set the new position
    element.style.left = `${newX}px`;
    element.style.top = `${newY}px`;

    // Update the position in the state continuously during the drag
    setSignatureFields((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? { ...field, x: newX, y: newY, pageIndex } // Update x, y during dragging
          : field
      )
    );
  }

  function onMouseUp() {
    if (!isDragging) return;

    isDragging = false;

    // Final position update (ensure it reflects in the state after dragging ends)
    const finalX = parseFloat(element.style.left);
    const finalY = parseFloat(element.style.top);

    // Update the signature field with the new position
    setSignatureFields((prev) =>
      prev.map((field) =>
        field.id === fieldId ? { ...field, x: finalX, y: finalY, pageIndex } : field
      )
    );

    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
  }
}